module.exports = __webpack_public_path__ + "static/media/2 7 Ordkjedetest-Starter-testen.610ad67c.mp3";